import SocketService from '@/services/socket.io';

import { normalizeGuid } from './scheduleTaskSocket';

/**
 * Ensure socket is up and joinChat the ChatThread for a schedule task.
 * Safe to call repeatedly — SocketService short-circuits duplicate joins.
 */
export function ensureJoinedChatThread(chatThreadId) {
  const threadKey = normalizeGuid(chatThreadId);
  if (!threadKey) return false;

  const socketService = SocketService.getInstance();
  socketService.ensureConnected?.();

  if (socketService.hasRoom(threadKey, 'joinChat')) return true;

  socketService.send('joinChat', {
    type: 'joinChat',
    threadId: threadKey,
    groupId: threadKey,
  });
  return true;
}

/** Pull taskId / chatThreadId from POST …/run (or task run) response shapes. */
export function extractLiveWatchFromRunResponse(response, scheduleId = null) {
  const root = response?.data && typeof response.data === 'object' ? response.data : response;
  if (!root || typeof root !== 'object') {
    return { scheduleId, taskId: null, chatThreadId: null };
  }

  const nested =
    root.task || root.aiAgentScheduleInternalTask || root.internalTask || root.result || null;

  const taskId =
    root.taskId ||
    root.aiAgentScheduleInternalTaskId ||
    nested?.id ||
    (root.id && (root.chatThreadId || root.status != null) ? root.id : null) ||
    null;

  const chatThreadId =
    root.chatThreadId || nested?.chatThreadId || root.threadId || nested?.threadId || null;

  return {
    scheduleId: scheduleId || root.aiAgentScheduleId || nested?.aiAgentScheduleId || null,
    taskId: taskId ? String(taskId) : null,
    chatThreadId: chatThreadId ? String(chatThreadId) : null,
  };
}
